import { render } from "./DockoutBooking.vue?vue&type=template&id=b50fe1bc&scoped=true"
import script from "./DockoutBooking.vue?vue&type=script&lang=js"
export * from "./DockoutBooking.vue?vue&type=script&lang=js"

import "./DockoutBooking.vue?vue&type=style&index=0&id=b50fe1bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50fe1bc"]])

export default __exports__